<template>
  <div>
    <div class="modal-root">
      <div class="mask" :style="{ display: visible ? '' : 'none' }"></div>
      <div class="modal-wrap" :style="{ display: visible ? '' : 'none' }">
        <div
          class="modal"
          :style="{
            width: typeof width === 'number' ? width + 'px' : width,
            height: height ? height + 'vh' : 'auto',
            transform: transform ? `scale(${transform})` : 'inherit',
          }"
        >
          <!-- top: height ? (100 - height) / 2 + 'vh' : '1vh', -->
          <div class="modal-content">
            <!-- <button class="modal-toggle modal-close">-</button> -->
            <a-button class="modal-close" ghost @click="close()" size="small"
              ><span class="ant-modal-close-x"><a-icon type="close" /></span
            ></a-button>
            <div class="modal-header" v-dragModal="isDrag">
              <div class="modal-title">{{ title }}</div>
            </div>
            <div class="modal-body">
              <slot></slot>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueDraggableResizable from 'vue-draggable-resizable'
export default {
  components: {
    VueDraggableResizable,
  },
  props: {
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: '',
    },
    width: {
      type: [String, Number],
      default: 520,
    },
    height: {
      type: [String, Number],
      default: 0,
    },
    transform: {
      type: [String, Number],
    },
    isDrag: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isShowModal: '',
    }
  },
  watch: {
    visible(val) {
      if (val) {
        document.querySelector('body').style.overflow = 'hidden'
      } else {
        document.querySelector('body').style.overflow = 'auto'
      }
      console.log(document.querySelector('body').style)
    },
  },
  methods: {
    close() {
      this.$emit('cancel')
    },
  },
}
</script>

<style lang="less" scoped>
.mask {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
}
.modal {
  box-sizing: border-box;
  color: rgba(0, 0, 0, 0.65);
  font-size: 14px;
  font-variant: tabular-nums;
  line-height: 1.5;
  list-style: none;
  font-feature-settings: 'tnum';
  position: relative;
  width: auto;
  margin: 0 auto;
  padding: 0;
  pointer-events: none;
}
.modal-wrap {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1000;
  // overflow: auto;
  outline: 0;
  display: flex;
  justify-content: center;
  align-items: center;
}
.modal-content {
  height: 100%;
  position: relative;
  background-color: #fff;
  background-clip: padding-box;
  border: 1px solid;
  box-shadow: 0 4px 12px rgba(0 0 0 / 15%);
  pointer-events: auto;
}
.modal-close {
  position: absolute;
  top: 0;
  right: 0;
  z-index: 10;
  padding: 0;
  color: rgba(0, 0, 0, 0.45);
  font-weight: 700;
  line-height: 1;
  text-decoration: none;
  background: transparent;
  border: 0;
  outline: 0;
  cursor: pointer;
  transition: color 0.3s;
}
.modal-header {
  padding: 10px 24px;
  color: rgba(0, 0, 0, 0.65);
  background: #4f8cf6;
  //   border-bottom: 1px solid #e8e8e8;
}
.modal-title {
  margin: 0;
  color: #fff;
  font-weight: 500;
  font-size: 15px;
  line-height: 22px;
  word-wrap: break-word;
}
.modal-body {
  //   padding: 24px;
  overflow: auto;
  overflow-x: hidden;
  font-size: 14px;
  line-height: 1.5;
  word-wrap: break-word;
  height: calc(100% - 43px);
}
</style>
